module.exports = __webpack_public_path__ + "static/media/interreg-2-seas-mers-zeeen-vertical.91f87fa9.jpg";